/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 14:37:07 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import { reducedRolesArray, rolesTextArray } from 'utils/roles';

export const booleanOptions = [
  { id: true, name: 'Yes' },
  { id: false, name: 'No' },
];

export const employmentTypeOptions = [
  { id: 'EMPLOYEE', name: `All the Organisation's projects` },
  { id: 'FREELANCER', name: 'Specific projects only' },
];

export const employmentRoleOptions = [
  { id: 'BUILDER', name: 'App User' },
  { id: 'APPROVER', name: 'Approver' },
  { id: 'PROJECT_MANAGER', name: 'Project Manager' },
  { id: 'MANAGER', name: 'Manager' },
  { id: 'SUPER_MANAGER', name: 'Super Manager' },
  { id: 'SUPER_ADMIN', name: 'Super Admin' },
];

export const subscriptionPeriodEnum = {
  annualPlan: 'ANNUAL',
  monthlyPlan: 'MONTHLY',
  freePlan: 'FREE',
};

export const planTypeOptions = {
  ANNUAL: 'annualPlan',
  MONTHLY: 'monthlyPlan',
};

export const reducedEmploymentRoleOptions = [
  { id: 'BUILDER', name: 'App User' },
  { id: 'APPROVER', name: 'Approver' },
  { id: 'PROJECT_MANAGER', name: 'Project Manager' },
  { id: 'MANAGER', name: 'Manager' },
  { id: 'SUPER_MANAGER', name: 'Super Manager' },
];

export const employmentStatusOptions = [
  { id: 'PENDING', name: 'Pending Invitation' },
  { id: 'ACCEPTED', name: 'Invite Accepted' },
];

export const subcontractorStatusOptions = [
  { id: 'PENDING', name: 'Pending' },
  { id: 'ACCEPTED', name: 'Accepted' },
  { id: 'REJECTED', name: 'Rejected' },
  { id: 'REVOKED', name: 'Revoked' },
];

export const inviteRoleOptions = (maxRole = null) => {
  if (maxRole && maxRole !== 'APPROVER') {
    return [{ id: 'BUILDER', name: 'Ap User' }];
  }
  return [
    { id: 'APPROVER', name: 'Approver' },
    { id: 'BUILDER', name: 'App User' },
  ];
};

export const numberOfInviteOptions = [
  { id: 'SINGLE', name: 'Single Invite' },
  { id: 'MULTIPLE', name: 'Multiple Invites' },
];

export const inputMethodOptions = [
  { id: 'MANUAL', name: 'Manual Entry' },
  { id: 'BULK', name: 'Bulk CSV Upload' },
];

export const userTypeOptions = [
  { id: 'EMPLOYEE', name: `All the Organisation's projects` },
  { id: 'FREELANCER', name: 'Specific projects only' },
];

export const towerStatusOptions = [
  { id: 'PLANNED', name: 'Planned' },
  { id: 'BUILT', name: 'Built' },
  { id: 'REQUIRES_REINSPECTION', name: 'Requires Reinspection' },
  { id: 'DISMANTLED', name: 'Dismantled' },
];

export const inspectionStatusOptions = [
  { id: 'APPROVED', name: 'Approved' },
  { id: 'DO_NOT_USE', name: 'Do Not Use' },
  { id: 'INSPECTED', name: 'Awaiting Approval' },
  // { id: 'NOT_APPROVED', name: 'Not Approved' },
  { id: 'REQUIRES_REINSPECTION', name: 'Requires Reinspection' },
];

export const towerEnvironmentOptions = [
  { id: 'INDOOR', name: 'Indoor' },
  { id: 'OUTDOOR', name: 'Outdoor' },
];

export const isQualifiedOptions = [
  { id: true, name: 'Qualified' },
  { id: false, name: 'Not Qualified' },
];

export const isExpired = [
  { id: true, name: 'Yes' },
  { id: false, name: 'No' },
];

export const activeInActiveOptions = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'INACTIVE', name: 'Inactive' },
];

export const adStatusOptions = [
  { id: 'DRAFT', name: 'Draft' },
  { id: 'ACTIVE', name: 'Active' },
  { id: 'ARCHIVED', name: 'Archived' },
];

export const createAdStatusOptions = [
  { id: 'DRAFT', name: 'Draft' },
  { id: 'ACTIVE', name: 'Active' },
];

export const checklistTypes = [
  {
    id: 'IN_APP_AUTO_APPROVE',
    name: 'resources.Project.checklistTypes.inAppAutoApprove',
  },
  {
    id: 'IN_APP_CMS_APPROVE',
    name: 'resources.Project.checklistTypes.inAppCmsApprove',
  },
  { id: 'IN_CMS', name: 'resources.Project.checklistTypes.inCms' },
];

export const platformHeightOptions = maxHeight => {
  const possibleHeights = [];
  for (let height = 0; height < maxHeight; height++) {
    possibleHeights.push({ id: height + 1, name: `${height + 1} m` });
  }
  return possibleHeights;
};

export const dynamicInviteRoleOptions = currentRole => {
  const roles = reducedRolesArray;
  if (currentRole && rolesTextArray.includes(currentRole)) {
    if (currentRole === 'SUPER_ADMIN') {
      return roles;
    }
    const roleIndex = rolesTextArray.findIndex(role => role === currentRole);
    return roles.slice(roleIndex - 1);
  }
  return [];
};

export const userStatus = [
  { id: 'active', name: 'active' },
  { id: 'inactive', name: 'inactive' },
];
